import { memo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";
import {
  mapStatus,
  getStatusColor,
  getDeliveryStatus,
} from "../../utils/functions";
import { deliveryStatusEnum } from "../../helpers/enums.js";

const DriverDeliveryItemTable = ({
  delivery,
  deliveryItems,
  deliveryItemsCount,
  pagination,
  handleChangePage,
  handleChangeRowsPerPage,
  handleItemStatusUpdate,
  editStatus,
  setEditStatus,
  selectedItemStatus,
  setSelectedItemStatus,
  loading,
}) => {
  const [statuses] = useState(
    deliveryStatusEnum.filter((status) =>
      [
        "pending",
        "on_the_way",
        "delivered",
        "failed",
        "returned",
        "damaged",
      ].includes(status.value),
    ),
  );

  return (
    <>
      <TableContainer>
        <Table sx={{ minWidth: 350 }} aria-label="tabla de bultos">
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", pt: "5px", pb: "10px" }}>
                ID Item
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", pt: "5px", pb: "10px" }}>
                Índice
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", pt: "5px", pb: "10px" }}>
                Estado
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && deliveryItems.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : deliveryItems && deliveryItems.length > 0 ? (
              deliveryItems.map((item) => (
                <TableRow
                  key={item.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell>{item.id}</TableCell>
                  <TableCell>
                    Bulto {item.item_index} de {item.total_items || "?"}
                  </TableCell>
                  <TableCell>
                    {editStatus.state && item.id === editStatus.id ? (
                      <Autocomplete
                        fullWidth
                        disabled={[
                          "delivered",
                          "returned",
                          "cancelled",
                          "damaged",
                        ].includes(delivery.status)}
                        id="shipping-item-select"
                        options={statuses}
                        getOptionLabel={(deliveryStatus) =>
                          deliveryStatus ? deliveryStatus.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option.value === value?.value
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ mt: "10px !important" }}
                            label="estado del bulto"
                            helperText={
                              selectedItemStatus === null && "Campo obligatorio"
                            }
                            error={selectedItemStatus === null}
                          />
                        )}
                        value={selectedItemStatus}
                        onChange={(event, status) =>
                          handleItemStatusUpdate(item, status.value)
                        }
                      />
                    ) : (
                      <>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            color: "#fff",
                            textAlign: "center",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            padding: "5px",
                            backgroundColor: getStatusColor(item.status),
                          }}
                          onClick={() => {
                            if (
                              [
                                "delivered",
                                "returned",
                                "cancelled",
                                "damaged",
                              ].includes(delivery.status) &&
                              delivery.substatus === "complete"
                            ) {
                              alert(
                                "Envío en estado final no es posible modificar",
                              );
                            } else {
                              setEditStatus({ id: item.id, state: true });
                              setSelectedItemStatus(
                                statuses.find(
                                  (data) => data.value === item.status,
                                ),
                              );
                            }
                          }}
                        >
                          {mapStatus(item.status)}
                        </Typography>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  <Typography variant="body2" color="text.secondary">
                    No hay bultos registrados para esta orden.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[100, 150, 200, 300]}
        component="div"
        count={deliveryItemsCount}
        rowsPerPage={pagination.rowsPerPage}
        page={pagination.page - 1}
        onPageChange={(e, newPage) => handleChangePage(newPage + 1)}
        onRowsPerPageChange={(e) =>
          handleChangeRowsPerPage(parseInt(e.target.value, 10))
        }
      />
    </>
  );
};

export default memo(DriverDeliveryItemTable);
